import React, { useState, useEffect, useRef } from 'react';
// import 'http://code.jquery.com/jquery-latest.min.js';
import './Landing.css';
// import './assets/vazir.css';
import logo from '../../assets/landing/vibinoLogo.svg';
import v01_01 from '../../assets/landing/v01-01.png';
import v02_01 from '../../assets/landing/v02-01.png';
import v03_01 from '../../assets/landing/v03-01.png';
import v05_01 from '../../assets/landing/v05-01.png';
import landing01 from '../../assets/landing/landing01.mp4';
import EntryForm from '../../components/VEntry/EntryForm';

const Landing = props => {
  const [popup, setPopup] = useState(false);
  const wrapperRef = useRef(null);

  useEffect(() => {
    /**
     * Alert if clicked on outside of element
     */
    function handleClickOutside(event) {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setPopup(false);
      }
    }
    // Bind the event listener
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [wrapperRef]);

  const clickHandler = () => {
    setPopup(true);
  };
  return (
    <>
      <div
        className="landingCover"
        style={{ display: popup ? 'flex' : 'none' }}
      // onClick={() => setPopup(false)}
      >
        <div className="landingRegisterBox" ref={wrapperRef}>
          <EntryForm form="register" />
        </div>
      </div>
      <div className={`landingContainer ${popup ? 'blur' : ''}`}>
        <div className="header">
          <div className="content">
            <div className="logo right">
              <img src={logo} alt="Monda" />
            </div>
            <button type="button" className="btn btnPrimary left mobileHide" onClick={clickHandler}>
              <span>همین حالا شروع کنید</span>
            </button>
          </div>
        </div>
        <div className="content">
          <div className="row row1">
            <div className="panelText right">
              <span className="title">همین حالا شروع کنید!</span>
              <p>
                اگه تو هم از طراحی بنر گرافیکی چیز زیادی نمیدونی و کار کردن با ابزارهای گرافیکی
                پیچیده مثل فتوشاپ برات سخت و غیر قابل درکه، پس بهت تبریک میگم؛ جای درستی اومدی!
              </p>
              <button type="button" className="btn btnPrimary center" onClick={clickHandler}>
                <span>همین حالا شروع کنید</span>
              </button>
            </div>
            <div className="panelImage left">
              <img src={v01_01} alt="" />
            </div>
          </div>
          <div className="row row2">
            <div className="panelImage right">
              <img src={v02_01} alt="" />
            </div>
            <div className="panelText left">
              <p>
                موندا یک ابزار طراحی گرافیکی آنلاین رایگانه که هر آدمی با کم ترین سطح دانش طراحی
                گرافیک میتونه در کوتاه ترین زمان ممکن کارِ طراحی پوستر، بنر واسه پست و استوری
                اینستاگرام و به طور کلی هر طرحی توی شبکه های اجتماعیش رو باهاش راه بندازه.
              </p>
              <button type="button" className="btn btnBlue center" onClick={clickHandler}>
                <span>با دو کلیک امتحانش کن</span>
              </button>
            </div>
          </div>
          <div className="row row3">
            <video controls poster="/assets/images/videoIntro.jpg">
              <source src={landing01} type="video/mp4" />
            </video>
          </div>
          <div className="row row4">
            <div className="panelImage right">
              <img src={v03_01} alt="" />
            </div>
            <div className="panelText left">
              <span className="title">پس منتظر چی هستی؟</span>
              <p>همین حالا اولین پوستر گرافیکی رایگان خودت رو با موندا طراحی کن!</p>
              <button type="button" className="btn btnPrimary center" onClick={clickHandler}>
                <span>امکانات پنل و ببین</span>
              </button>
            </div>
          </div>
          <div className="row row5">
            <div className="panelText right landingRegisterBox">
              <EntryForm form="register" />
            </div>
            <div className="panelImage left">
              <img src={v05_01} alt="" />
            </div>
          </div>
          <br />
          <br />
          <br />
        </div>
      </div>
    </>
  );
};
export default Landing;
